import Vue from 'vue';
import {Watch} from 'vue-property-decorator';
import Component from 'vue-class-component';

/**
 * This mixin provides `attrs$` and `listeners$` to work around
 * vue bug https://github.com/vuejs/vue/issues/10115
 */

@Component
export default class BindAttrs extends Vue {
    attrs$: Record<string, string> = {};
    listeners$: Record<string, any | any[]> = {};

    @Watch('$attrs', {
        immediate: true
    }) onAttrsChanged(val: any, oldVal: any) {
        for (const attr in oldVal) {
            if (!oldVal.hasOwnProperty(attr)) {
                this.$delete(this.attrs$, attr);
            }
        }
        for (const attr in val) {
            if (val.hasOwnProperty(attr)) {
                this.$set(this.attrs$, attr, val[attr]);
            }
        }
    }

    @Watch('$listeners', {
        immediate: true
    }) onListenersChanged(val: any, oldVal: any) {
        for (const attr in oldVal) {
            if (!oldVal.hasOwnProperty(attr)) {
                this.$delete(this.listeners$, attr);
            }
        }
        for (const attr in val) {
            if (val.hasOwnProperty(attr)) {
                this.$set(this.listeners$, attr, val[attr]);
            }
        }
    }

}
